import React from 'react';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Typography,
  Box,
  Chip
} from '@mui/material';
import { Analysis } from '../../types';
import { StatusChip } from '../common';

interface RecentAnalysesTableProps {
  analyses: Analysis[];
}

const RecentAnalysesTable: React.FC<RecentAnalysesTableProps> = ({ analyses }) => {
  if (analyses.length === 0) {
    return (
      <Box sx={{ textAlign: 'center', py: 4 }}>
        <Typography color="text.secondary">
          No recent analyses available.
        </Typography>
      </Box>
    );
  }

  return (
    <TableContainer component={Paper}>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>Analysis ID</TableCell>
            <TableCell>Product</TableCell>
            <TableCell>Result</TableCell>
            <TableCell>Confidence</TableCell>
            <TableCell>Risk Level</TableCell>
            <TableCell>Status</TableCell>
            <TableCell>Processing Time</TableCell>
            <TableCell>Date</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {analyses.map((analysis) => (
            <TableRow key={analysis.id} hover>
              <TableCell>
                <Typography variant="body2" fontFamily="monospace">
                  {analysis.analysis_id.slice(0, 8)}...
                </Typography>
              </TableCell>
              <TableCell>
                <Typography variant="body2">
                  {analysis.test_product_name || 'Unknown Product'}
                </Typography>
                {analysis.test_product_seller && (
                  <Typography variant="caption" color="text.secondary" display="block">
                    Seller: {analysis.test_product_seller}
                  </Typography>
                )}
              </TableCell>
              <TableCell>
                <Chip
                  label={analysis.is_counterfeit ? 'Counterfeit' : 'Authentic'}
                  color={analysis.is_counterfeit ? 'error' : 'success'}
                  size="small"
                />
              </TableCell>
              <TableCell>
                <Typography variant="body2">
                  {(analysis.confidence_score * 100).toFixed(1)}%
                </Typography>
              </TableCell>
              <TableCell>
                <StatusChip status={analysis.risk_level} variant="risk" />
              </TableCell>
              <TableCell>
                <StatusChip status={analysis.status} variant="analysis" />
              </TableCell>
              <TableCell>
                <Typography variant="body2">
                  {analysis.processing_time ? `${analysis.processing_time.toFixed(1)}s` : 'N/A'}
                </Typography>
              </TableCell>
              <TableCell>
                <Typography variant="body2">
                  {new Date(analysis.created_at).toLocaleDateString()}
                </Typography>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default RecentAnalysesTable;